export const config = {
    wsNumber: '584125354531'
}